import CloseIcon from '@mui/icons-material/Close'
import { Dialog, DialogContent, DialogTitle } from '@mui/material'
import IconButton from '@mui/material/IconButton'
import axios from 'api/axios-configure'
import { LoadingSpinner } from 'components/LoadingSpinner'
import { TableReport } from 'components/TableReport'
import { Icon, Tooltip } from 'monday-ui-react-core'
import React, { useContext, useEffect, useMemo, useRef, useState } from 'react'
import { toast } from 'react-toastify'
import { StatementContext } from 'utils/context/StatementsContext'
import pdfIcon from './../../assest/images/pdf-icon.svg'
import { DocumentTypes } from '../../utils/Constants'

const ReceiverList = ({type, open, onClose, documentSystemNumber, statementType }) => {
    const { getPayoutStatementPDF, getProductBalancingStatementPDF } = useContext(StatementContext)
    const [columnVisibility, setColumnVisibility] = useState({
        // createdDate: false,
        // senderName: type === Usertype.SENDER ? false : true,
         ownerCountry: statementType === DocumentTypes.PRODUCT_BALANCING ? false : true,
    })
    const [pagination, setPagination] = useState({
        pageIndex: 0,
        pageSize: 25, //customize the default page size
    })
    const [sorting, setSorting] = useState([])
    const [rowCount, setRowCount] = useState(0)
    const [tableData, setTableData] = useState([])
    const [isFetching, setIsFetching] = useState(false)
    const isMounted = useRef(false)
    const [rowSelection, setRowSelection] = useState({})

    const columns = useMemo(
        () => [
            {
                header: 'Actions',
                size: 60,
                maxSize: 60,
                enableSorting: false,
                Cell: ({ row }) => {
                    return (
                        <div className="d-flex align-items-center">
                            <Tooltip content="Download PDF">
                                <Icon
                                    iconSize={24}
                                    iconType={Icon.type.SRC}
                                    icon={pdfIcon}
                                    iconLabel="pdf icon"
                                    className="icon-story-custom-icon actions-icon"
                                    onClick={() =>
                                        handlePdfIconClick(row.original)
                                    }
                                />
                            </Tooltip>
                        </div>
                    )
                },
            },
            {
                size: 140,
                maxSize: 140,
                accessorKey: 'ownerNumber',
                header: (
                    <>
                        <div title="Owner Number">
                            <div className="fw-bold header-container">
                                Owner
                            </div>
                            <div className="fw-bold header-container">
                                Number
                            </div>
                        </div>
                    </>
                ),
            },
            {
                size: 140,
                maxSize: 140,
                accessorKey: 'ownerName1',
                header: (
                    <>
                        <div title="Owner Name">
                            <div className="fw-bold header-container">
                                Owner
                            </div>
                            <div className="fw-bold header-container">Name</div>
                        </div>
                    </>
                ),
            },
            {
                size: 140,
                maxSize: 140,
                accessorKey: 'ownerAddress1',
                header: (
                    <>
                        <div title="Owner Address">
                            <div className="fw-bold header-container">
                                Owner
                            </div>
                            <div className="fw-bold header-container">
                                Address
                            </div>
                        </div>
                    </>
                ),
            },
            {
                size: 140,
                maxSize: 140,
                accessorKey: 'ownerCity',
                header: (
                    <>
                        <div title="Owner City">
                            <div className="fw-bold header-container">
                                Owner
                            </div>
                            <div className="fw-bold header-container">City</div>
                        </div>
                    </>
                ),
            },
            {
                size: 70,
                maxSize: 70,
                accessorKey: 'ownerState',
                header: (
                    <>
                        <div title="Owner State">
                            <div className="fw-bold header-container">
                                Owner
                            </div>
                            <div className="fw-bold header-container">
                                State
                            </div>
                        </div>
                    </>
                ),
            },
            {
                size: 140,
                maxSize: 140,
                accessorKey: 'ownerZip5',
                header: (
                    <>
                        <div title="Owner Zip">
                            <div className="fw-bold header-container">
                                Owner
                            </div>
                            <div className="fw-bold header-container">Zip</div>
                        </div>
                    </>
                ),
            },
            {
                size: 70,
                maxSize: 70,
                accessorKey: 'ownerCountry',
                header: (
                    <>
                        <div title="Owner Country">
                            <div className="fw-bold header-container">
                                Owner
                            </div>
                            <div className="fw-bold header-container">
                                Country
                            </div>
                        </div>
                    </>
                ),
            },
            {
                size: 140,
                maxSize: 140,
                accessorKey: 'accessedDate',
                header: (
                    <>
                        <div title="Accessed Date">
                            <div className="fw-bold header-container">
                                Accessed
                            </div>
                            <div className="fw-bold header-container">
                                Date
                            </div>
                        </div>
                    </>
                ),
            }
        ],
        []
    )

    const pbColumns = useMemo(
        () => [
            {
                header: 'Actions',
                size: 60,
                maxSize: 60,
                enableSorting: false,
                Cell: ({ row }) => {
                    return (
                        <div className="d-flex align-items-center">
                            <Tooltip content="Download PDF">
                                <Icon
                                    iconSize={24}
                                    iconType={Icon.type.SRC}
                                    icon={pdfIcon}
                                    iconLabel="pdf icon"
                                    className="icon-story-custom-icon actions-icon"
                                    onClick={() =>
                                        handlePdfIconClick(row.original)
                                    }
                                />
                            </Tooltip>
                        </div>
                    )
                },
            },
            {
                size: 140,
                maxSize: 140,
                accessorKey: 'ownerNumber',
                header: (
                    <>
                        <div title="Owner Number">
                            <div className="fw-bold header-container">
                                Owner
                            </div>
                            <div className="fw-bold header-container">
                                Number
                            </div>
                        </div>
                    </>
                ),
            },
            {
                size: 140,
                maxSize: 140,
                accessorKey: 'ownerName1',
                header: (
                    <>
                        <div title="Owner Name">
                            <div className="fw-bold header-container">
                                Owner
                            </div>
                            <div className="fw-bold header-container">Name</div>
                        </div>
                    </>
                ),
            },
            {
                size: 140,
                maxSize: 140,
                accessorKey: 'ownerAddress1',
                header: (
                    <>
                        <div title="Owner Address">
                            <div className="fw-bold header-container">
                                Owner
                            </div>
                            <div className="fw-bold header-container">
                                Address
                            </div>
                        </div>
                    </>
                ),
            },
            {
                size: 140,
                maxSize: 140,
                accessorKey: 'ownerCity',
                header: (
                    <>
                        <div title="Owner City">
                            <div className="fw-bold header-container">
                                Owner
                            </div>
                            <div className="fw-bold header-container">City</div>
                        </div>
                    </>
                ),
            },
            {
                size: 70,
                maxSize: 70,
                accessorKey: 'ownerState',
                header: (
                    <>
                        <div title="Owner State">
                            <div className="fw-bold header-container">
                                Owner
                            </div>
                            <div className="fw-bold header-container">
                                State
                            </div>
                        </div>
                    </>
                ),
            },
            {
                size: 140,
                maxSize: 140,
                accessorKey: 'ownerZip5',
                header: (
                    <>
                        <div title="Owner Zip">
                            <div className="fw-bold header-container">
                                Owner
                            </div>
                            <div className="fw-bold header-container">Zip</div>
                        </div>
                    </>
                ),
            },
            {
                size: 140,
                maxSize: 140,
                accessorKey: 'accessedDate',
                header: (
                    <>
                        <div title="Accessed Date">
                            <div className="fw-bold header-container">
                                Accessed
                            </div>
                            <div className="fw-bold header-container">
                                Date
                            </div>
                        </div>
                    </>
                ),
            }
        ],
        []
    )

    const showDownloadToast = (fileType) => {
        toast.success(`Downloading ${fileType}`, {
            position: toast.POSITION.BOTTOM_RIGHT,
            className: 'toastify__toast--success-custom',
            bodyClassName: 'toastify-body',
            progressClassName: 'toastify-progress-bar',
        })
    }

    const handlePdfIconClick = (row) => {
        showDownloadToast('PDF')
        const { runId, ownerName1 } = row
        const postData = []
        const data = {
            documentSystemNumber: documentSystemNumber,
            ownerName: ownerName1,
            runId,
        }
        postData.push(data)

        if (postData.length) {
            if (statementType === DocumentTypes.PRODUCT_BALANCING) 
                getProductBalancingStatementPDF(postData, type)
            else
                getPayoutStatementPDF(postData, type)
        }
    }

    const GetReceiverList = () => {
        if (!open) return

        setIsFetching(true)
        const data = {
            documentSystemNumber: documentSystemNumber,
            pageNumber: pagination.pageIndex + 1,
            pageSize: pagination.pageSize,
            sortDesc: sorting[0]?.desc,
            SortBy: sorting[0]?.id,
        }
        const url = statementType === DocumentTypes.PRODUCT_BALANCING ? '/GetProductBalancingReceivers' : '/GetPayoutReceivers';
        axios
            .post(url, data)
            .then((response) => {
                setTableData(response.data.items)
                setRowCount(response.data.totalCount)
                isMounted.current = true
            })
            .catch(() => setIsFetching(false))
            .finally(() => setIsFetching(false))
    }

    const onDownloadButtonClicked = (rows) => {
        const selectedRows = Object.keys(rows)
        const postData = selectedRows.map(row => {
            const splittedKey = row.split(',')
            return {
                documentSystemNumber: splittedKey[0],
                runId: splittedKey[1],
                ownerName: splittedKey[2] ?? ''
            }
        })
        showDownloadToast('PDF')
        if (statementType === "PB") 
            getProductBalancingStatementPDF(postData, type)
        else
            getPayoutStatementPDF(postData, type)
    }

    useEffect(() => {
        GetReceiverList()
    }, [documentSystemNumber])

    useEffect(() => {
        if (isMounted.current) {
            GetReceiverList()
        }
    }, [pagination.pageIndex, pagination.pageSize])

    useEffect(() => {
        if (isMounted.current) {
            GetReceiverList()
        }
    }, [sorting])

    return (
        <>
            <Dialog
                open={open}
                onClose={onClose}
                PaperProps={{
                    component: 'form',
                }}
                fullWidth={true}
                maxWidth="lg"
            >
                <DialogTitle>Receiver List</DialogTitle>
                <IconButton
                    aria-label="close"
                    onClick={onClose}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                    }}
                >
                    <CloseIcon />
                </IconButton>
                <DialogContent>
                    <section className="statements-container mb-5">
                        <div className="table-wrapper">
                            {!isFetching ? (
                                <TableReport
                                    setRowSelection={setRowSelection}
                                    rowSelection={rowSelection}
                                    enableManualSorting={true}
                                    setColumnVisibility={setColumnVisibility}
                                    onPaginationChange={setPagination}
                                    pagination={pagination}
                                    sorting={sorting}
                                    onSortingChange={setSorting}
                                    enableRowSelection={(row) => true}
                                    rowCount={rowCount}
                                    columnVisibility={columnVisibility}
                                    columns={statementType === 'PB' ? pbColumns : columns}
                                    rowId={(row) => { 
                                        if(tableData.length > 0)
                                            return (row.documenT_SYSTEM_NUMBER ?? '') + ',' + (row.runId ?? '') + ',' + (row.ownerName1 ?? '')
                                    }}
                                    tableData={tableData}
                                    onDownloadButtonClicked={
                                        onDownloadButtonClicked
                                    }
                                />
                            ) : (
                                <LoadingSpinner />
                            )}
                        </div>
                    </section>
                </DialogContent>
            </Dialog>
        </>
    )
}

export default ReceiverList
